'use strict'

import $ from 'jquery';
import { lib } from '../../common/Library';
import { tableLib } from '../../common/TableLibrary';

/**
 * 個別銘柄 - 企業発表推移テーブル
 *
 * @param {string} divId 表示div id
 */
const ZaimuDpsTable = function (divId) {
    let jsonData = [];

    try {
        // グラフ生成 - データ用JSONを読み込む
        $.ajax({
            url: $('#dpsTableJsonUrl').val(),
            dataType: 'jsonp',
            jsonpCallback: 'z_dps_table' + $('#stockCd').val(),
            async: false
        })
        .done(function (json) {
            // テーブルデータ加工
            editJsonData(json);

            // テーブルを生成
            createZaimuDpsTable(divId);

            $(divId).find('.even td').css('background', '#fff');
            $(divId).find('.color td').css('background', '#fde9d9');
            $(divId).find('.detail_num').css('font-weight', 'bold');
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            //json取得エラー
            console.log('status:' + textStatus);
            console.log('response:' + jqXHR.responseText);
        });
    } catch (e) {
        console.log(e);
    }

    /**
     * JSONデータを編集
     *
     * @param {Array} json データファイルJSON
     */
    function editJsonData(json) {
        // 利用するJSONデータの抽出
        let kessanNum = $('#dpsKessanNum').val();
        $.each(json, function (idx, data) {
            if (data.KESSAN_NUM <= kessanNum) {
                jsonData.push(data);
            }
        });

        // 表示用データの作成
        $.each(jsonData, function () {
            //会計基準文字列
            switch (this.ACCOUNTING_STANDARD_FLG) {
                //日本会計基準
                case 1:
                    this.ACCOUNTING_STANDARD_STR = '';
                    break;
                //SEC
                case 2:
                    this.ACCOUNTING_STANDARD_STR = 'S';
                    break;
                //IFRS
                case 3:
                    this.ACCOUNTING_STANDARD_STR = 'I';
                    break;
                default:
                    this.ACCOUNTING_STANDARD_STR = '';
            }

            //変則決算
            if (this.NUMBER_MONTHS !== 12 && this.KESSAN_NUM > 0) {
                this.IRREGULAR_SETTLEMENT_STR = '変';
            } else {
                this.IRREGULAR_SETTLEMENT_STR = '';
            }
        });
    }

    /**
     * テーブルを生成
     *
     * @param {string} divId グラフ出力先の<div>タグのID
     * @param {Object} jsonData データJSON
     */
    function createZaimuDpsTable(divId) {
        let table = $('<table/>').addClass('graph_table').css('table-layout', 'fixed'),
            thead = $('<thead/>').appendTo(table),
            theadTr = $('<tr/>').appendTo(thead);

        //ヘッダー部（上段）
        let th = $('<th/>').text('決算期').appendTo(theadTr).addClass('fiscal_year header');
        $('<br/>').appendTo(th);

        th = $('<th/>').text('日付').appendTo(theadTr).addClass('data_1 header').css('width', '100px');
        $('<br/>').appendTo(th);

        th = $('<th/>').text('予・実').appendTo(theadTr).addClass('data_1 header').css('width', '50px');
        $('<br/>').appendTo(th);

        th = $('<th/>').text('発表区分').appendTo(theadTr).addClass('data_1 header').css('width', '70px');
        $('<br/>').appendTo(th);

        th = $('<th/>').text('1Q').appendTo(theadTr).addClass('data_1 header');
        $('<br/>').appendTo(th);

        th = $('<th/>').text('2Q').appendTo(theadTr).addClass('data_1 header');
        $('<br/>').appendTo(th);

        th = $('<th/>').text('3Q').appendTo(theadTr).addClass('data_1 header');
        $('<br/>').appendTo(th);

        th = $('<th/>').text('期末').appendTo(theadTr).addClass('data_1 header');
        $('<br/>').appendTo(th);

        th = $('<th/>').text('合計').appendTo(theadTr).addClass('data_1 header');
        $('<br/>').appendTo(th);

        //データ部
        let tbody = $('<tbody/>').appendTo(table),
            tbodyTr,
            td,
            numClass,
            zebra;

        $.each(jsonData, function (value) {
            if (value % 2 === 1) {
                zebra = 'even';
            } else {
                zebra = 'odd';
            }

            tbodyTr = $('<tr/>').appendTo(tbody).addClass(zebra);

            if (this.FY_TERM_FLG_TXT === '実') {
                $(tbodyTr).addClass('color');
            }

            //決算期の表示形式を変更
            td = $('<td/>')
                .appendTo(tbodyTr)
                .addClass('detail_year')
                .text(tableLib.convFiscalYear(this.FISCAL_YEAR));

            //日付
            td = $('<td/>')
                .appendTo(tbodyTr)
                .addClass('detail_type_center');
            $('<span/>')
                .text(this.ANNOUNCE_DATE)
                .appendTo(td);

            //予・実
            td = $('<td/>')
                .appendTo(tbodyTr)
                .addClass('detail_type_center');
            $('<span/>')
                .text(this.FY_TERM_FLG_TXT)
                .appendTo(td);

            //発表区分
            td = $('<td/>')
                .appendTo(tbodyTr)
                .addClass('detail_type_center');
            $('<span/>')
                .text(this.ANN_FLG_TXT)
                .appendTo(td);

            //1Q
            numClass = tableLib.getNumClass(this.DPS_1Q);
            td = $('<td/>')
                .appendTo(tbodyTr)
                .addClass('detail_num');

            if (this.DPS_1Q_FLG_TXT === '予') {
                $('<span/>')
                    .text(this.DPS_1Q_FLG_TXT + ' ' + tableLib.numberFormat(this.DPS_1Q, 2))
                    .addClass(numClass)
                    .appendTo(td);
            } else {
                $('<span/>')
                    .text(tableLib.numberFormat(this.DPS_1Q, 2))
                    .addClass(numClass)
                    .appendTo(td);
            }

            //2Q
            numClass = tableLib.getNumClass(this.DPS_2Q);
            td = $('<td/>')
                .appendTo(tbodyTr)
                .addClass('detail_num');
            if (this.DPS_2Q_FLG_TXT === '予') {
                $('<span/>')
                    .text(this.DPS_2Q_FLG_TXT + ' ' + tableLib.numberFormat(this.DPS_2Q, 2))
                    .addClass(numClass)
                    .appendTo(td);
            } else {
                $('<span/>')
                    .text(tableLib.numberFormat(this.DPS_2Q, 2))
                    .addClass(numClass)
                    .appendTo(td);
            }

            //3Q
            numClass = tableLib.getNumClass(this.DPS_3Q);
            td = $('<td/>')
                .appendTo(tbodyTr)
                .addClass('detail_num');
            if (this.DPS_3Q_FLG_TXT === '予') {
                $('<span/>')
                    .text(this.DPS_3Q_FLG_TXT + ' ' + tableLib.numberFormat(this.DPS_3Q, 2))
                    .addClass(numClass)
                    .appendTo(td);
            } else {
                $('<span/>')
                    .text(tableLib.numberFormat(this.DPS_3Q, 2))
                    .addClass(numClass)
                    .appendTo(td);
            }

            //期末
            numClass = tableLib.getNumClass(this.DPS_END);
            td = $('<td/>')
                .appendTo(tbodyTr)
                .addClass('detail_num');
            if (this.DPS_END_FLG_TXT === '予') {
                $('<span/>')
                    .text(this.DPS_END_FLG_TXT + ' ' + tableLib.numberFormat(this.DPS_END, 2))
                    .addClass(numClass)
                    .appendTo(td);
            } else {
                $('<span/>')
                    .text(tableLib.numberFormat(this.DPS_END, 2))
                    .addClass(numClass)
                    .appendTo(td);
            }

            //合計
            numClass = tableLib.getNumClass(this.DPS_ALL);
            td = $('<td/>')
                .appendTo(tbodyTr)
                .addClass('detail_num');
            if (this.DPS_ALL_FLG_TXT === '予') {
                $('<span/>')
                    .text(this.DPS_ALL_FLG_TXT + ' ' + tableLib.numberFormat(this.DPS_ALL, 2))
                    .addClass(numClass)
                    .appendTo(td);
            } else {
                $('<span/>')
                    .text(tableLib.numberFormat(this.DPS_ALL, 2))
                    .addClass(numClass)
                    .appendTo(td);
            }
        });

        //出力
        $(divId).html(table);
    }
};

export { ZaimuDpsTable };
